import {action, makeObservable} from 'mobx';

import {i18n} from '@yourcoach/i18n';

import type {TextInput} from '../../../../uikit/TextInput';
import type {GetComponentProps} from '../../../../utils/utility-types';
import type {TextQuestionModel} from '../../Question/TextQuestion/TextQuestion.model';
import type {AnswerModelProps} from '../Answer.model';

import {
  createTextInputField,
  type TextInputField,
} from '../../../../utils/validation';
import {AnswerModel} from '../Answer.model';

const MAX_LENGTH = 255;

export class TextAnswerModel extends AnswerModel<string, TextQuestionModel> {
  field: TextInputField;

  constructor(props: AnswerModelProps<string, TextQuestionModel>) {
    super(props);

    this.field = createTextInputField(`${props.question.id}:answer`, {
      validationRule: {
        max: MAX_LENGTH,
        messages: {
          max: i18n.t('shared:validation.field_max_length', {max: MAX_LENGTH}),
          required: i18n.t('shared:validation.field_required'),
        },
        optional: !props.question.isRequired,
        type: 'string',
      },
    });

    if (props.value) {
      this.field.setValue(props.value);
    }

    makeObservable(this, {
      onChange: action.bound,
    });
  }

  get isValid(): boolean {
    return Boolean(this.field.isValid);
  }

  onChange(
    action: Parameters<GetComponentProps<typeof TextInput>['onChange']>[0],
  ): void {
    this.field.onChange?.(action);

    this.value = action.payload?.text ?? '';
  }

  toString(): string {
    return this.value ?? '';
  }
}
